import { initLibrary } from '@travelata-libs/travelata-frontend';
import { ApiService } from '@travelata-libs/utils';
import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import sentryService from '@/js/common/plugins/logger';
import getStore from '@ve/services/getStore/getStore';
declare let window: any;

export default () => {
    const apiService = new ApiService(window.location.origin);
    initLibrary({ 
        store: getStore(), 
        config: {
            ...window.appConfig,
            baseHost: window.origin,
        },
        sentry: sentryService,
        tracker: trackingService, 
        apiService 
    });
}